// extracted by mini-css-extract-plugin
export default {"quarterHeight":"9","slotHeight":"36"};